/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'

export default class LuiNotificationGroup extends LuiBase {
  static get is() {
    return 'lui-notification-group'
  }

  onConnected() {
    super.onConnected()

    const wrapper = this._createDiv('lui-notification-group__wrapper')
    const banners = this._createDiv('lui-notification-group__banners')
    const toasts = this._createDiv('lui-notification-group__toasts')

    wrapper.append(banners)
    wrapper.append(toasts)

    this.parentElement.insertBefore(wrapper, this)
  }

  _createDiv(className) {
    const element = document.createElement('div')
    element.classList.add(className)
    return element
  }

  add(title, options = {}) {
    this.addBanner(title, options)
  }

  addBanner(title, options = {}) {
    const el = this._createNotification(title, options)
    this.banners.appendChild(el)
    el.show()
  }

  addToast(content, options = {}) {
    const el = this._createNotification(content, options)
    el.setAttribute('variant', 'toast')

    if (options.title) {
      const title = document.createElement('span')
      title.setAttribute('slot', 'title')
      title.innerHTML = options.title
      el.appendChild(title)
    }

    this.toasts.appendChild(el)
    el.show()
  }

  _createNotification(content, options) {
    const el = document.createElement('lui-notification')
    el.innerHTML = content
    if (options.impact) {
      el.setAttribute('impact', options.impact)
    }
    if (options.timeout) {
      el.setAttribute('timeout', options.timeout === true ? '' : options.timeout)
    }
    if (options.icon) {
      const icon = document.createElement('lui-icon')
      icon.setAttribute('slot', 'icon')
      icon.setAttribute('icon', options.icon)
      el.appendChild(icon)
    }

    return el
  }

  get banners() {
    this._banners = this._banners || document.querySelector('.lui-notification-group__banners')
    return this._banners
  }

  get toasts() {
    this._toasts = this._toasts || document.querySelector('.lui-notification-group__toasts')
    return this._toasts
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-notification/lui-notification-group.js
// module id = 266
// module chunks = 0 1 5